import { CoreIcon } from '../core-icon';
import ticketFillSVG from '../../assets/icons/ticket-fill.svg';
import type { IconProps } from '../core-icon';

export const TicketFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={ticketFillSVG} {...props} />;
};
